<template>
  <v-container>
    <!-- 헤이홈 토큰 등록 섹션 -->
    <div class="setting-section">
      <v-list-item-title class="text-h6 font-weight-medium d-flex align-center mb-4">
        <v-icon color="primary" class="mr-2">mdi-file-upload</v-icon>
        헤이홈 토큰 등록
      </v-list-item-title>

      <div class="d-flex align-start mb-4">
        <div
            class="json-drop-area"
            @dragover.prevent="onTokenDOver"
            @dragleave.prevent="onTokenDLeave"
            @drop.prevent="onDropJsonFile"
            :class="{ 'dragover': isDragOver }"
            @click="onTokenFileInput"
        >
          <v-icon size="24" color="primary">mdi-file-upload</v-icon>
          <span class="ml-2 cursor-pointer">JSON 파일을 드래그하거나 클릭하여 업로드</span>
          <input
              type="file"
              ref="tokenFileInput"
              accept=".json"
              style="display: none"
              @change="onFileSelected"
          >
        </div>
        <div v-if="0 < tokensFromFile.length" class="ml-4 d-flex">
          <div
              class="action-button"
              @click="onResetTokenFileInput"
              style="background: rgba(var(--v-theme-error), 0.05);"
          >
            <v-icon size="24" color="error">mdi-close</v-icon>
          </div>
          <div
              class="action-button ml-2"
              @click="onSendTokens"
          >
            <v-progress-circular
                v-if="isSending"
                color="primary"
                indeterminate
                :size="24"
                :width="2"
            ></v-progress-circular>
            <v-icon v-else size="24" color="primary">mdi-check</v-icon>
          </div>
        </div>
        <div v-else-if="0 < tokensFromRemote.length" class="ml-4 d-flex">
          <div
              class="action-button"
              @click="onSendTokens"
          >
            <v-progress-circular
                v-if="isSending"
                color="primary"
                indeterminate
                :size="24"
                :width="2"
            ></v-progress-circular>
            <v-icon v-else size="24" color="primary">mdi-refresh</v-icon>
          </div>
        </div>
      </div>
      <div v-if="jsonError" class="text-error mb-4">{{ jsonError }}</div>

      <v-expand-transition>
        <div v-if="0 < tokens.length">
          <v-divider class="mb-4"></v-divider>
          <v-table density="comfortable" class="account-table">
            <thead>
            <tr>
              <th class="text-subtitle-1 font-weight-medium owner-column">owner</th>
              <th class="text-subtitle-1 font-weight-medium token-column">token</th>
              <th class="text-subtitle-1 font-weight-medium device-column" v-if="tokensFromFile.length === 0">online</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="({owner, token, online, offline}) in tokens" :key="token">
              <td class="owner-column">{{ owner }}</td>
              <td class="token-column text-truncate">{{ token }}</td>
              <td class="device-column" v-if="tokensFromFile.length === 0">{{ `${online} / ${online + offline}`}}</td>
            </tr>
            </tbody>
          </v-table>
        </div>
      </v-expand-transition>
    </div>
    <v-card>
      <v-list rounded>
        <v-list-subheader>일반</v-list-subheader>
        <v-list-item class="pt-2 pb-2" append-icon="mdi-chevron-right" @click="onTelegramBotToken">
          <template #title>텔레그램 봇 토큰</template>
          <template #subtitle>{{ setting.telegramBotToken }}</template>
          <template #append v-if="isLoading">
            <v-progress-circular color="grey-lighten-1" :size="24" :width="2" indeterminate></v-progress-circular>
          </template>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item class="pt-2 pb-2" append-icon="mdi-chevron-right" @click="onLinks">
          <template #title>링크</template>
          <template #subtitle>{{ setting.links.map(({subject}) => subject).join(', ') }}</template>
          <template #append v-if="isLoading">
            <v-progress-circular color="grey-lighten-1" :size="24" :width="2" indeterminate></v-progress-circular>
          </template>
        </v-list-item>
      </v-list>
    </v-card>
    <v-dialog max-width="600" v-model="dialog.telegramBotToken.isOpened">
      <v-card>
        <v-toolbar color="pink">
          <v-toolbar-title>
            텔레그램 봇 토큰 수정
          </v-toolbar-title>
        </v-toolbar>
        <v-card-item>
          <v-text-field
              label="토큰"
              density="compact"
              hide-details
              v-model="dialog.telegramBotToken.text"
              @keyup.enter="dialog.telegramBotToken.onOk"
          ></v-text-field>
        </v-card-item>
        <v-card-actions class="justify-end">
          <v-btn @click="dialog.telegramBotToken.onCancel">취소</v-btn>
          <v-btn variant="tonal" @click="dialog.telegramBotToken.onOk">적용</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="600" v-model="dialog.link.isOpened">
      <v-card>
        <v-toolbar color="pink">
          <v-toolbar-title>
            링크
          </v-toolbar-title>
          <template #append>
            <v-btn-toggle density="comfortable" v-model="dialog.link.draggable">
              <v-btn variant="tonal" :value="true"
                  :icon="dialog.link.draggable ? 'mdi-sort' : 'mdi-sort-variant-off'"
              ></v-btn>
            </v-btn-toggle>
          </template>
        </v-toolbar>
        <v-list v-if="0 < dialog.link.items.length">
          <draggable v-model="dialog.link.items" item-key="id" handle=".handle">
            <template #item="{element, index}">
              <v-list-item :title="element.subject" :subtitle="element.href" @click="onLink(element)">
                <template #append>
                  <v-icon class="handle" @mousedown.stop v-if="dialog.link.draggable">mdi-menu</v-icon>
                  <v-icon @click.stop="onLinkDelete(element)" v-else>mdi-close</v-icon>
                </template>
              </v-list-item>
            </template>
          </draggable>
        </v-list>
        <div class="pa-2 text-body-2 text-center" v-else>링크를 등록해 주세요.</div>
        <v-card-actions class="justify-end">
          <v-btn @click="onLink()">추가</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="dialog.link.onCancel">취소</v-btn>
          <v-btn variant="tonal" @click="dialog.link.onOk">적용</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="600" v-model="dialog.linkDetail.isOpened">
      <v-card>
        <v-card-item>
          <v-text-field
              label="제목"
              density="compact"
              hide-details
              v-model="dialog.linkDetail.subject"
              @keyup.enter="dialog.linkDetail.onOk"
          ></v-text-field>
          <v-text-field
              class="mt-2"
              label="링크"
              density="compact"
              hide-details
              v-model="dialog.linkDetail.href"
              @keyup.enter="dialog.linkDetail.onOk"
          ></v-text-field>
        </v-card-item>
        <v-card-actions class="justify-end">
          <v-btn @click="dialog.linkDetail.onCancel">취소</v-btn>
          <v-btn variant="tonal" @click="dialog.linkDetail.onOk">적용</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script setup>
import {computed, inject, onMounted, reactive, ref} from 'vue';
import {useRouter} from "vue-router";
import {useAppStore} from "@/stores/app";
import {useSessionStore} from "@/stores/session";
import debugModule from 'debug';
import {wrapDebug} from "@/common/utils";
const debug = wrapDebug(debugModule('setting'));
import draggable from 'vuedraggable';

const axios = inject('axios');
const network = inject('network');
const router = useRouter();
const appStore = useAppStore();
const sessionStore = useSessionStore();

const dialog = reactive({
  telegramBotToken: {
    isOpened: false,
    text: '',
  },
  link: {
    isOpened: false,
    items: [],
  },
  linkDetail: {
    isOpened: false,
    subject: '',
    href: '',
  },
});

const setting = reactive({
  telegramBotToken: '',
  links: [],
});

const isLoading = ref(true);

const tokensFromRemote = ref([]);
const tokensFromFile = ref([]);
const tokenFileInput = ref(null);

const tokens = computed(() =>
    tokensFromFile.value.length ? tokensFromFile.value : tokensFromRemote.value
);


const isDragOver = ref(false);
const jsonError = ref('');
const isSending = ref(false);

onMounted(() => {
  (async () => {
    isLoading.value = true;
    try {
      await loadSetting();
    } catch (error) {
      debug(`loadSetting failed: ${error}`);
    }
    isLoading.value = false;
  })();
});

const loadSetting = async () => {
  try {
    const response = await axios.get(`/api/setting`);
    if (!response || 200 !== response.status || 0 !== response.data.code) return;
    if (!response.data.response || 0 === response.data.response.length) return;

    const _setting = response.data.response.reduce((acc, cur) => ({
      ...acc,
      [cur.name.replace(/-([a-z])/g, g => g[1].toUpperCase())]: cur.value,
    }), {});
    const links = _setting['links'];
    _setting['links'] = links && 0 < links.length && JSON.parse(links) || [];
    Object.entries(_setting).map(([k, v]) => setting[k] = v);

    await loadTokens();

  } catch (error) {
    console.log(error);
  }
};

const loadTokens = async () => {
  try {
    const response = await axios.get(`/api/setting/tokens`);
    tokensFromRemote.value = response && response.data &&
        response.data.response || []

  } catch (error) {
    console.log(error);
  }
};

const onTokenDOver = () => {
  isDragOver.value = true;
};

const onTokenDLeave = () => {
  isDragOver.value = false;
};

const parseTokenFile = async file => {
  if (!file.name.endsWith('.json')) {
    jsonError.value = 'JSON 파일만 업로드할 수 있습니다.';
    return;
  }
  try {
    tokensFromFile.value = await new Promise(r => {
      const reader = new FileReader();
      reader.onload = event => {
        const content = JSON.parse(event.target.result);
        const tokens = Object.entries(content).flatMap(([owner, tokens]) =>
            tokens.map(token => ({
              owner: owner.replace(/^token_/, ''),
              token: token,
            }))
        );
        r(tokens);
      };
      reader.readAsText(file);
    });
  } catch (error) {
    jsonError.value = 'JSON 파일 형식이 올바르지 않습니다.';
  }
};

const onFileSelected = (event) => {
  const file = event.target.files[0];
  if (!file) return;
  parseTokenFile(file);
};

const onDropJsonFile = (event) => {
  isDragOver.value = false;
  jsonError.value = '';
  const file = event.dataTransfer.files[0];
  if (!file) return;
  parseTokenFile(file);
};

const onTokenFileInput = () => {
  tokenFileInput.value.click();
};

const onResetTokenFileInput = () => {
  tokensFromFile.value = [];
  if (tokenFileInput.value) {
    tokenFileInput.value.value = '';
  }
};

const onSendTokens = async () => {
  if (isSending.value) return;

  isSending.value = true;
  try {
    if (0 < tokensFromFile.value.length)
      await axios.post(`/api/setting/tokens`, tokensFromFile.value);
    else if (0 < tokensFromRemote.value.length)
      await axios.get(`/api/setting/retrieveDevices`);
    await loadTokens();
    onResetTokenFileInput();

  } catch (error) {
    console.error(error);
  }
  isSending.value = false;
};

const onTelegramBotToken = () => {
  (async () => {
    const done = await new Promise(r => dialog.telegramBotToken = {
      isOpened: true,
      text: setting.telegramBotToken,
      onCancel: () => r(false),
      onOk: () => r(true),
    });
    dialog.telegramBotToken.isOpened = false;
    if (!done) return;

    try {
      const response = await axios.post(`/api/setting`, {
        name: 'telegram-bot-token', value: dialog.telegramBotToken.text,
      });
      if (!response || 200 !== response.status || 0 !== response.data.code) return;

      await appStore.loadTelegramChatIds();
      await loadSetting();

    } catch (error) {
      console.log(error);
    }
  })();
};

const onLinks = () => {
  (async () => {
    const done = await new Promise(r => dialog.link = {
      isOpened: true,
      items: JSON.parse(JSON.stringify(setting.links)),
      onCancel: () => r(false),
      onOk: () => r(true),
    });
    dialog.link.isOpened = false;
    if (!done) return;

    try {
      const response = await axios.post(`/api/setting`, {
        name: 'links', value: JSON.stringify(dialog.link.items),
      });
      if (!response || 200 !== response.status || 0 !== response.data.code) return;

      await loadSetting();

    } catch (error) {
      console.log(error);
    }
  })();
};

const onLink = link => {
  (async () => {
    const done = await new Promise(r => dialog.linkDetail = {
      isOpened: true,
      subject: link && link.subject,
      href: link && link.href,
      onCancel: () => r(false),
      onOk: () => r(true),
    });
    dialog.linkDetail.isOpened = false;
    if (!done) return;

    if (link) {
      link.subject = dialog.linkDetail.subject;
      link.href = dialog.linkDetail.href;
    } else {
      dialog.link.items.push({
        subject: dialog.linkDetail.subject,
        href: dialog.linkDetail.href,
      });
    }
  })();
};

const onLinkDelete = link => {
  if (!confirm(`${link.subject}을(를) 삭제하시겠습니까?`)) return;

  dialog.link.items = dialog.link.items.filter(item => item !== link);
};
</script>

<style scoped>
.setting-section {
  background: rgb(var(--v-theme-surface));
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  border: 1px solid rgba(var(--v-theme-on-surface), 0.12);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.setting-section:last-child {
  margin-bottom: 0;
}

.json-drop-area {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border: 1px solid rgb(var(--v-theme-primary));
  border-radius: 8px;
  padding: 16px;
  min-height: 48px;
  background: rgba(var(--v-theme-primary), 0.05);
  cursor: pointer;
  transition: all 0.2s ease;
  max-width: 350px;
  font-size: 15px;
}

.json-drop-area.dragover {
  background: rgba(var(--v-theme-primary), 0.1);
  border-color: rgb(var(--v-theme-primary));
}

.json-error {
  color: rgb(var(--v-theme-error));
  font-size: 13px;
}

.action-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgb(var(--v-theme-primary));
  border-radius: 8px;
  min-width: 48px;
  min-height: 48px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.action-button:hover {
  background: rgba(var(--v-theme-primary), 0.1);
}

.account-table {
  background: transparent;
  table-layout: fixed;
  width: 100%;
}

.account-table th {
  font-weight: 600;
  color: rgba(var(--v-theme-on-surface), 0.87);
}

.account-table td {
  padding: 12px 16px;
}

.owner-column {
  width: auto;
}

.token-column {
  overflow: hidden;
  text-overflow: ellipsis;
}

.device-column {
  width: auto;
  text-align: right;
  white-space: nowrap;
}

.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dialog {
  max-width: 600px;
}

.dialog >>> .v-text-field .v-field--variant-outlined .v-field__input {
  min-height: 28px;
  padding: 0 5px;
}

</style>
